@if (_active) {
  <kendo-window
    [class.editFieldsModeClass]="_pageState == 4"
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : '' }}"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="fullWidthFormForm"
    [class.disabledPopup]="_editFormActive || _orderingTabsForm || _deactivatedFieldsForm"
    (keydown.enter)="$event.preventDefault()"
    #mainWindow>
    <!-- Form -->
    <form novalidate [formGroup]="_form" class="form_style">
      <div class="row special_row_margin">
        <div class="col-6 special_col_padding"
          [class.col-12]="_pageState == 2 || _pageState == 4">
          <div class="border_sections margin-top-4 bordered-With-charts">
            <div class="row">
              <div class="col-12">
                <h2 class="formsTitle">
                  Location Type
                  @if (canAccess('customers', 'update')) {
                    <span (click)="_edit()"
                      [class.ViewModeVisibleElement]="_pageState == 1"
                      class="action-button action-button-viewMode">
                      <div class="action-button-icon">
                        <img src="/assets/menu/enterprise/edit-action-icon-grid.svg" />
                      </div>
                      <div class="edit-icon-text">Edit</div>
                    </span>
                  }
                </h2>
                <div class="upsert-header-buttons">
                  <ul class="menuButtonsList">
                    @if (canAccess('customers', 'update') && this._currentUser.appRole.id!=3 && this._currentUser.appRole.id!=4) {
                      <li (click)="_onEditForms()"
                        [class.ViewModelHiddenElement]="_pageState != 2">
                        Edit Forms
                      </li>
                    }
                    @if (this._currentUser.appRole.id!=3 && this._currentUser.appRole.id!=4) {
                      <li class="wikiButton"
                        (click)="_onEditFields()"
                        [class.ViewModeHiddenElement]="_pageState != 2"
                        >
                        Edit Fields
                      </li>
                    }
                    <li class="wikiButton"
                      (click)="_returnAdNew()"
                      [class.ViewModeHiddenElement]="_pageState != 4">
                      Close Edit Fields
                    </li>
                    <!-- <li [class.ViewModeHiddenElement]="_pageState == 1">Edit Forms</li> -->
                    <!-- <li class="wikiButton">Wiki</li> -->
                    @if (_pageState == 2 && !_currentUser.isEnterprise) {
                      <li
                        class="wikiButton"
                        [class.disabled]="_deactivatedFieldsGridData?.length == 0"
                        (click)="_viewInactiveFields();_deactivatedFieldsForm=true">
                        View Inactive Fields
                      </li>
                    }
                    @if (_pageState == 2) {
                      <li
                        class="wikiButton"
                        [class.disabled]="_deactivatedFormTabsGridData?.length == 0"
                        (click)="_viewInactiveFormTabs();_deactivatedFormTabsForm=true"
                        >
                        View Inactive Form Tabs
                      </li>
                    }
                  </ul>
                  @if (_pageState != 1) {
                    <div>
                      <button kendoButton
                        class="steps_buttons_class"
                        (click)="_onCancel()">
                        <img class="backimage"
                          [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                          <span>close</span>
                        </button>
                        @if (canAccess('locationTypes', 'create')) {
                          <button
                            kendoButton
                            class="steps_buttons_class"
                            [disabled]="_pageState == 4 ? true : false"
                            (click)="_onSave('saveAndCopy')">
                            <img class="backimage"
                              [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                              <span>save & Copy</span>
                            </button>
                          }
                          @if (canAccess('locationTypes', 'create')) {
                            <button
                              kendoButton
                              class="steps_buttons_class"
                              [disabled]="_pageState == 4 ? true : false"
                              (click)="_onSave('saveAndNew')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save & New</span>
                              </button>
                            }
                            <button kendoButton
                              class="steps_buttons_class"
                              [disabled]="_pageState == 4 ? true : false"
                              (click)="_onSave('saveAndClose')">
                              <img class="backimage"
                                [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                <span>save & Close</span>
                              </button>
                              <button kendoButton
                                class="steps_buttons_class"
                                [disabled]="_pageState == 4 ? true : false"
                                (click)="_onSave('save')">
                                <img class="backimage"
                                  [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                  <span>save</span>
                                </button>
                              </div>
                            }
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="formsMenuSeparator"></div>
                        </div>
                      </div>
                      <div class="row row_padding">
                        <fieldset class="col-12"
                          [class.col-6-imp]="_pageState == 2 || _pageState == 4">
                          <div KendoToolTip
                            class="form-group from_but_container special_style_formgroup margin-top-10">
                            <label for="code" class="control-label">{{getLabel("LBL_LocTypeID")?.currentText}}</label>
                            <input #kendo_BarcodeGen_Location_Type_ID
                              [class.ViewModeDisabledControl]="_pageState == 1"
                              type="text"
                              class="k-textbox writebox min-width-0 newFormControlWidth"
                              [placeholder]="'code'"
                              [readonly]="_pageState == 1"
                              (keyup.enter)="_barcodeSubmited()"
                              (keydown.Tab)="_barcodeSubmited()"
                              formControlName="code"
                              entityName="locationTypes"
                              [formControl]="_locationCode"
                              required />
                              <a title="Generate Barcode"
                                class="cursor-pointer"
                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                (click)="_generateBarcodeClick()">
                                <img class="searchIcon"
                                  [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                </a>
                                <a title="Edit {{getLabel('LBL_LocTypeID')?.currentText}}"
                                  [class.editfieldsIconvisible]="_pageState == 4"
                                  class="editFieldsIcon"
                                  (click)="_openRenameForm('LBL_LocTypeID', true)">
                                  <img class="searchIcon"
                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                  </a>
                                </div>
                                @if (getAuthByLabel('LBL_LocTypeDesc')?.canView) {
                                  <div KendoToolTip
                                    class="form-group special_style_formgroup">
                                    <label for="description" class="control-label">{{getLabel("LBL_LocTypeDesc")?.currentText}}</label>
                                    <input #locationTypeDescription
                                      [class.ViewModeDisabledControl]="_pageState == 1"
                                      type="text"
                                      class="k-textbox writebox newFormControlWidth"
                                      formControlName="description"
                                      placeholder="Description"
                                      [readonly]="_pageState == 1"
                                      [attr.disabled]="getAuthByLabel('LBL_LocTypeDesc')?.canEdit ? null : 'disabled'"
                                      [attr.required]="getLabel('LBL_LocTypeDesc')?.isRequired ? 'required' : null" />
                                      <a title="Edit {{getLabel('LBL_LocTypeDesc')?.currentText}}"
                                        [class.editfieldsIconvisible]="_pageState == 4"
                                        class="editFieldsIcon"
                                        (click)="_openRenameForm('LBL_LocTypeDesc')">
                                        <img class="searchIcon"
                                          [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                        </a>
                                      </div>
                                    }
                                  </fieldset>
                                </div>
                              </div>
                            </div>
                            @if (_pageState != 2 && _pageState != 4) {
                              <div class="col-6 special_col_padding"
                                >
                                <div class="border_sections margin-top-4 bordered-With-charts">
                                  @if ((_currentUser && _currentUser.isEnterprise)) {
                                    <div class="col-12 charts-container upsert-donut-chart"
                                      >
                                      <!-- <ng-container *ngFor="let chart of _donutChartSmall">
                                      <div
                                        class="donut-component-single-container"
                                        (click)="_openCirclesForm()"
                                        >
                                        <asap-donut-chart
                                          class=""
                                          [model]="chart"
                                          [chartTooltip]="_tooltipVisibilityUpsert"
                                          >
                                        </asap-donut-chart>
                                        <div class="dont-chart-title">{{chart.title}}</div>
                                      </div>
                                    </ng-container> -->
                                  </div>
                                }
                                @if ((_currentUser && !_currentUser.isEnterprise)) {
                                  <div class="col-12 appliance-Sharts-Container"
                                    >
                                    <div class="tabsSection">
                                      <ul class="tabsectionList">
                                        <!-- <li
                                        [class.activetabShart]="_NOSActive"
                                        (click)="_NOSTabClick()"
                                        class="LS"
                                        >
                                        Nbr of stock
                                      </li> -->
                                      <!-- <li [class.activetabShart]="_INVENTORYIDActive" (click)="_INVENTORYIDTabClick()"
                                    class="LS">Inventory Id</li>
                                    <li [class.activetabShart]="_BCActive" (click)="_BCTabClick()" class="LS">By
                                    Category</li> -->
                                  </ul>
                                </div>
                                <!-- <div
                                (click)="OnOpenStockItemForm($event)"
                                *ngIf="_NOSActive && locationTypeChart && _stockItemGridColumns"
                                class="stock-item-chart"
                                >
                                <apx-chart
                                  [title]="locationTypeChart.title"
                                  [series]="locationTypeChart.series"
                                  [chart]="locationTypeChart.chart"
                                  [xaxis]="locationTypeChart.xaxis"
                                  [stroke]="locationTypeChart.stroke"
                                  [dataLabels]="locationTypeChart.dataLabels"
                                ></apx-chart>
                              </div> -->
                            </div>
                          }
                        </div>
                      </div>
                    }
                  </div>
                  <!-- <kendo-tabstrip [tabPosition]="_kendoTabStripPosition" (tabSelect)="_onTabSelect($event)">
                  <kendo-tabstrip-tab *ngFor="let customTab of _customTabs; let i = index" [title]="customTab.name">
                    <ng-template kendoTabContent>
                      <div class="tabcontent">
                        <fieldset class="contenttabstyle margin-top-10">
                          <asap-custom-fields-form [customFields]="_customFields[customTab.id]"
                            [pageState]="_pageState" [accounts]="_selectedAccountIds" [formName]="'stock'"
                            page="locationTypes" [invalidSubmit]="_invalidSubmit"
                            (customFieldsValue)="_customFieldsValueChanges($event, customTab.id)"
                            (customFieldsDeleteValue)="_removeCustomField($event)"
                            (customFieldsEditValue)="_openCustomRenameForm($event, customTab.id)"
                            (customFieldsStatus)="formStatus($event)">
                          </asap-custom-fields-form> -->
                          <div class="example-wrapper">
                            <div class="row no_row_margin">
                              <div class="col-8 col-lg-8 col-xl-8 responsive_style numericboxtab"
                                #kendo_tabstrip_wrapper>
                                @if (_hasCustomTabs() || _currentUser.isEnterprise) {
                                  <kendo-tabstrip [tabPosition]="_kendoTabStripPosition"
                                    (tabSelect)="_onTabSelect($event)"
                                    >
                                    <!-- Accounts Tab -->
                                    @if (_currentUser && _currentUser.isEnterprise) {
                                      <kendo-tabstrip-tab
                                        #accountTab title="Accounts"
                                        [selected]="_currentUser && _currentUser.isEnterprise">
                                        <ng-template kendoTabContent>
                                          <div class="greytabtop menumobilecontainer">
                                            <img class="mobiletabIcon"
                                              (click)="_mobileMenuToggle()"
                                              [src]="'/assets/menu/'+ _theme +'/fields-menu-icon.svg'" />
                                            </div>
                                            <div class="tabcontent tabWizGridInside accountTab"
                                              [class.active]="_addClassActive">
                                              <asap-account-sites-selection
                                                [class.ViewModeDisabledControl]="_pageState == 1"
                                                [disabled]="_pageState == 1"
                                                [selectedAccounts]="_selectedAccounts"
                                                [enableSiteSelection]="false"
                                                [resolver]="_getAccounts"
                                                (onRowSelectionChanges)="_onAccountRowSelectionChanges($event)">
                                              </asap-account-sites-selection>
                                            </div>
                                          </ng-template>
                                        </kendo-tabstrip-tab>
                                      }
                                      @for (tab of _dataTabs; track tab) {
                                        @if (tab.isCustom ) {
                                          <kendo-tabstrip-tab
                                            [disabled]="!_tabEnabled && _currentUser.isEnterprise"
                                            [selected]="_dataTabs.indexOf(tab) == 1"
                                            [title]="tab.name">
                                            <ng-template kendoTabContent>
                                              <div class="tabcontent">
                                                <fieldset class="contenttabstyle margin-top-10">
                                                  <asap-custom-fields-form [customFields]="_ReturnCustfield(tab.id)"
                                                    [pageState]="_pageState"
                                                    [accounts]="_selectedAccountIds"
                                                    [formName]="'stock'"
                                                    page="locationTypes"
                                                    [invalidSubmit]="_invalidSubmit"
                                                    (customFieldsValue)="_customFieldsValueChanges($event, tab.id)"
                                                    (customFieldsDeleteValue)="_removeCustomField($event)"
                                                    (customFieldsEditValue)="_openCustomRenameForm($event, tab.id)"
                                                    (customFieldsStatus)="formStatus($event)"
                                                    [_customFieldsValue]="_customFieldsValue">
                                                  </asap-custom-fields-form>
                                                  <div class="form-group special_style_formgroup">
                                                    <button kendobutton
                                                      class="addNewFieldButton k-button"
                                                      (click)="_addNewField(tab.id)">
                                                      <img class="backimage"
                                                        src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Field</span>
                                                      </button>
                                                    </div>
                                                    <div class="form-group special_style_formgroup">
                                                      <button kendobutton
                                                        class="addNewFieldButton k-button"
                                                        (click)="_deactivateTab(tab.id, 'stockItems')">
                                                        <img class="backimage"
                                                          src="/assets/menu/enterprise/add-icon-green.svg" /><span>Deactivate Tab</span>
                                                        </button>
                                                      </div>
                                                    </fieldset>
                                                  </div>
                                                </ng-template>
                                              </kendo-tabstrip-tab>
                                            }
                                          }
                                        </kendo-tabstrip>
                                      }
                                    </div>
                                    <!-- <div class="col-4 col-lg-4 col-xl-4 responsive_style">
                                    <div class="borderedNotesContainer">
                                      <note
                                        #note
                                        [_pageState]="_pageState"
                                        [_model]="_model"
                                        [_page]="_page"
                                      ></note>
                                    </div>
                                  </div> -->
                                </div>
                              </div>
                              <div class="row no_row_margin">
                                <div class="col-12">
                                  <button kendobutton
                                    class="addNewtabButton k-button"
                                    (click)="_addNewTab()">
                                    <img class="backimage"
                                      src="/assets/menu/enterprise/add-icon-green.svg" /><span>Add New Tab</span>
                                    </button>
                                  </div>
                                </div>
                                <div class="row no_row_margin">
                                  <div class="col-12">
                                    <button kendobutton
                                      class="reorderTabButton k-button"
                                      (click)="_reorderingtabs()">
                                      <img class="backimage"
                                        src="/assets/menu/enterprise/reorder-tabs-icon.svg" /><span>reorder tabs</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-12">
                                      @if (_invalidForm) {
                                        <asap-forms-validation-summary
                                          [form]="_form"
                                          [page]="'locationTypes'"
                                          [customValidation]="_customValidation"
                                          [additionalErrors]="_additionalErrors">
                                        </asap-forms-validation-summary>
                                      }
                                    </div>
                                  </div>
                                </form>
                                @if (CheckIfWeAreInEditMode()) {
                                  <div class="asap-footer">
                                    <ul class="asap-footer-content-list">
                                      <li>
                                        <span class="label-footer">Date Added:</span>{{
                                        _model.createdOn |
                                        dateFormat
                                        }}<span class="separator">.</span><span class="label-footer">Added By User:</span>{{
                                        _model.createdUser?
                                        _model.createdUser.userName : null
                                        }}
                                      </li>
                                      <li>
                                        <span class="label-footer">Last Edited:</span>{{
                                        _model.lastUpdatedOn |
                                        dateFormat
                                        }}<span class="separator">.</span><span class="label-footer">Last Edited By User:</span>{{_model.updatedUser? _model.updatedUser.userName : null}}
                                      </li>
                                    </ul>
                                  </div>
                                }
                                <!-- <asap-dialog-layout *ngIf="_isDialiog"
                                [data]="_dialogModel"
                                [componentName]="_dialogComponentName"
                                (closeDialog)="_closeDialog($event)">
                              </asap-dialog-layout> -->
                              @if (_isEditForms || _deactivatedFormTabsForm) {
                                <div class="k-overlay"></div>
                              }
                            </kendo-window>
                          }
                          @if (_showCirclesForm) {
                            <kendo-window
                              title="Location Type Per Account"
                              (keydown.enter)="$event.preventDefault()"
                              (close)="_closeCirclesForm()">
                              <div class="col-12 donut-form-container">
                                @for (chart of _donutChartLarge; track chart) {
                                  <div class="donut-component-single-container">
                                    <asap-donut-chart class=""
                                      [model]="chart"
                                      [chartTooltip]="_tooltipVisibilityForm">
                                    </asap-donut-chart>
                                    <div class="dont-chart-title">{{chart.title}}</div>
                                  </div>
                                }
                              </div>
                            </kendo-window>
                          }

                          @if (_editFormActive) {
                            <kendo-window
                              title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                              (close)="_closeCustomFields()"
                              class="customFieldsWindow">
                              <asap-custom-fields [accounts]="_selectedAccountIds"
                                [tabGroup]="_selectedTabId"
                                [labelId]="_selectedLabelId"
                                [labelObjectCode]="_selectedLabelObjectCode"
                                [formName]="'stock'"
                                page="locationTypes"
                                [isCustomfieldsForm]="_isCustomfieldsFormValue"
                                [isCustomtabsForm]="_isAddTabFormValue"
                                [isRenameForm]="_isRenameFormValue"
                                [language]="_language"
                                [isRenameCustomForm]="_isRenameCustomFormValue"
                                [isRenameLabel]="_isRenameLabel"
                                [isMandatory]="_isMandatory"
                                (closePopup)="ClosePopup($event)"
                                [permissionScope]="_permissionScope">
                              </asap-custom-fields>
                            </kendo-window>
                          }

                          @if (_orderingTabsForm) {
                            <kendo-window
                              title="Tab Reordering"
                              (keydown.enter)="$event.preventDefault()"
                              (close)="_closeOrderingTabsForm()">
                              <div class="row no_row_margin py-2 margin-top-4 border_sections">
                                <div class="col-12">
                                  <button kendoButton class="steps_buttons_class" (click)="_onSaveTabOrdering()">
                                    <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                                    <span>Save & Close</span>
                                  </button>
                                </div>
                              </div>
                              <div class="row no_row_margin p-3 margin-top-30">
                                @if (false) {
                                  <div class="col-12 margin-top-10">
                                    <div class="form-group">
                                      <label for="itemType" class="control-label">Tab 1</label>
                                      <kendo-combobox [data]="_dataTabsSelected"
                                        [suggest]="true"
                                        [textField]="'name'"
                                        [valueField]="'name'"
                                        placeholder="Accounts/Sites"
                                        class="newFormControlWidth disabled">
                                      </kendo-combobox>
                                    </div>
                                  </div>
                                }
                                @for (item of _dataTabs ; track item; let i = $index) {
                                  <div class="col-12 margin-top-10">
                                    <div class="form-group">
                                      <label for="itemType" class="control-label">Tab {{ i + 1 }}</label>
                                      <kendo-combobox [data]="_dataTabsSelected"
                                        [suggest]="true"
                                        [textField]="'name'"
                                        [valueField]="'name'"
                                        [placeholder]="item.name"
                                        required
                                        class="bordered newFormControlWidth"
                                        (valueChange)="_comboValueChange($event,i)">
                                      </kendo-combobox>
                                    </div>
                                  </div>
                                }
                              </div>
                            </kendo-window>
                          }

                          @if (_deactivatedFieldsForm) {
                            <kendo-window title="Deactivated Fields" (close)="_closeInactiveFields()">
                              <div class="row no_row_margin margin-top-30">
                                <div class="col-12 margin-top-10">
                                  <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                                    <kendo-grid-column field="name" title="Fields Name">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="formTab.name" title="Tab Name">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.createdOn | dateFormat}}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="lastUpdatedOn"
                                      title="Deactivation Date"
                                      type="date">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.lastUpdatedOn | dateFormat}}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="Command" title="Command">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <div class="action-button action-button-deactivate"
                                          (click)="_reactivate(dataItem)">
                                          <div class="action-button-icon">
                                            <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                          </div>
                                          <div class="edit-icon-text">Reactivate</div>
                                        </div>
                                      </ng-template>
                                    </kendo-grid-column>
                                  </kendo-grid>
                                </div>
                              </div>
                            </kendo-window>
                          }

                          @if (isOpenStockItemForm) {
                            <kendo-window
                              title="Stock item per location type"
                              (keydown.enter)="$event.preventDefault()"
                              (close)="OnCloseStockItemForm()"
                              class="fullWidthFormForm">
                              <div class="col-12">
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Stock item per location type - Graph
                                        <span [ngClass]="isStockItemChartExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                          class="float-right pointer-click mt-2 mr-2"
                                        (click)="ExpandCollapseStockItemChart(isStockItemChartExpanded)"></span>
                                      </div>
                                    </div>
                                  </div>
                                  @if (isStockItemChartExpanded) {
                                    <div class="graph-container-display">
                                      <apx-chart [title]="locationTypeChart.title"
                                        [series]="locationTypeChart.series"
                                        [chart]="locationTypeChart.chart"
                                        [xaxis]="locationTypeChart.xaxis"
                                        [stroke]="locationTypeChart.stroke"
                                      [dataLabels]="locationTypeChart.dataLabels"></apx-chart>
                                    </div>
                                  }
                                </div>
                                <div class="asap-section-container zero-padding">
                                  <div class="row zeromarginRow">
                                    <div class="col-12 zeroPaddingColumn">
                                      <div class="header-section-gray">
                                        Stock item per location type - Grid
                                        <span [ngClass]="isStockItemGridExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                          class="float-right pointer-click mt-2 mr-2"
                                        (click)="ExpandCollapseStockItemGrid(isStockItemGridExpanded)"></span>
                                      </div>
                                    </div>
                                    @if (isStockItemGridExpanded) {
                                      <div class="col-12 zeroPaddingColumn">
                                        <div class="col-12 mt-1 mb-2 chart-code-description">
                                          <span>Location type {{_model.code}}</span>
                                        </div>
                                        @if (_stockItemGridColumns) {
                                          <asap-grid-layout
                                            [page]="'stockItems'"
                                            [pagingEnabled]="false"
                                            [sortingEnabled]="true"
                                            [filteringEnable]="true"
                                            [headerEnable]="true"
                                            [importEnable]="true"
                                            [exportExcelEnable]="true"
                                            [exportPDFEnable]="true"
                                            [orderEnable]="true"
                                            [headerTitle]="'Stock item'"
                                            [enableSiteSelection]="false"
                                            [resolver]="_getStockItemByLocationType"
                                            class="ListGrid"
                                            [refreshInitData]="true"
                                            [withHeader]="false">
                                            @for (column of _stockItemGridColumns; track column) {
                                              @if (column.selected) {
                                                @if (column.isTemplate && (column.field != 'quantityPerAccount')) {
                                                  <ng-template pageListColumn
                                                    [field]="column.field"
                                                    [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                    [type]="column.type"
                                                    let-item>
                                                    @if (column.field == 'inventoryUnitOfMeasure.code') {
                                                      {{item.inventoryUnitOfMeasure?.code}}
                                                    }
                                                    @if (column.field == 'inventoryUnitOfMeasure.unitName') {
                                                      {{item.inventoryUnitOfMeasure?.unitName}}
                                                    }
                                                    @if (column.field == 'receiveUnitOfMeasure.code') {
                                                      {{item.receiveUnitOfMeasure?.code}}
                                                    }
                                                    @if (column.field == 'receiveUnitOfMeasure.unitName') {
                                                      {{item.receiveUnitOfMeasure?.unitName}}
                                                    }
                                                    @if (column.field == 'issueUnitOfMeasure.code') {
                                                      {{item.issueUnitOfMeasure?.code}}
                                                    }
                                                    @if (column.field == 'issueUnitOfMeasure.unitName') {
                                                      {{item.issueUnitOfMeasure?.unitName}}
                                                    }
                                                    @if (column.field == 'itemType.name') {
                                                      {{item.itemType?.name}}
                                                    }
                                                    @if (column.field == 'category.id') {
                                                      {{item.category?.id}}
                                                    }
                                                    @if (column.field == 'category.description') {
                                                      {{item.category?.description}}
                                                    }
                                                    @if (column.field == 'costType.code') {
                                                      {{item.costType?.code}}
                                                    }
                                                    @if (column.field == 'costInfo.cost') {
                                                      {{$safeNavigationMigration(item.costInfo?.cost) | costFormat}}
                                                    }
                                                    @if (column.field == 'costInfo.markupPercent') {
                                                      {{$safeNavigationMigration(item.costInfo?.markupPercent) | costFormat}}
                                                    }
                                                    @if (column.field == 'costInfo.markupNumber') {
                                                      {{$safeNavigationMigration(item.costInfo?.markupNumber) | costFormat}}
                                                    }
                                                    @if (column.field == 'stockItemLeads.stockitemleadtime') {
                                                      {{getStockItemLeadsString(item.stockItemLeads)}}
                                                    }
                                                    @if (column.field == 'stockItemSites.site.id') {
                                                      {{getSitesString(item.stockItemSites, true)}}
                                                    }
                                                    @if (column.field == 'stockItemSites.site.name') {
                                                      {{getSitesString(item.stockItemSites, false)}}
                                                    }
                                                    @if (column.field == 'account') {
                                                      {{getAccountsString(item.stockItemSites)}}
                                                    }
                                                    @if (column.field == 'createdUser.username') {
                                                      {{item.createdUser?.username}}
                                                    }
                                                    @if (column.field == 'receiveUnitOfMeasure.multiplier') {
                                                      {{item.receiveUnitOfMeasure?.multiplier}}
                                                    }
                                                    @if (column.field == 'inventoryUnitOfMeasure.multiplier') {
                                                      {{item.inventoryUnitOfMeasure?.multiplier}}
                                                    }
                                                    @if (column.field == 'defaultLocation.description') {
                                                      {{item.defaultLocation?.description}}
                                                    }
                                                    @if (column.field == 'category.categoryFiles') {
                                                      {{
                                                      item.category?.categoryFiles ?
                                                      getCategoryImage($safeNavigationMigration(item.category?.categoryFiles)) : null
                                                      }}
                                                    }
                                                    @if (column.field == 'stockItemFiles.file') {
                                                      {{getStockImage(item.stockItemFiles)}}
                                                    }
                                                    @if (column.field == 'stockItemVendors') {
                                                      {{
                                                      item.stockItemVendors ?
                                                      getVendors(item.stockItemVendors) : null
                                                      }}
                                                    }
                                                    @if (column.field == 'stockItemLeads.stockItemLeadid') {
                                                      {{getTimeUnitCode(item.stockItemLeads)}}
                                                    }
                                                    @if (column.field == 'stockItemLeads.stockitemleadinterval') {
                                                      {{getTimeUnit(item.stockItemLeads)}}
                                                    }
                                                    @if (column.field == 'isShopping') {
                                                      {{item.isShopping}}
                                                    }
                                                  </ng-template>
                                                }
                                                @if (!column.isTemplate) {
                                                  <ng-template pageListColumn
                                                    [field]="column.field"
                                                    [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                                                    [type]="column.type"
                                                    let-item>
                                                    @if (column.type == 'date') {
                                                      {{ item[column.field] | dateFormat }}
                                                    }
                                                    @if (column.type != 'date') {
                                                      {{item[column.field]}}
                                                    }
                                                    @if (column.field == 'costInfo.fixedUnitPrice') {
                                                      {{$safeNavigationMigration(item.costInfo?.fixedUnitPrice) | costFormat}}
                                                    }
                                                    @if (column.field == 'costInfo.cost') {
                                                      {{$safeNavigationMigration(item.costInfo?.cost) | costFormat}}
                                                    }
                                                  </ng-template>
                                                }
                                              }
                                            }
                                          </asap-grid-layout>
                                        }
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                              <div class="col-12 margin-top-10">
                                <button kendoButton
                                  class="steps_buttons_class"
                                  (click)="OnCloseStockItemForm()">
                                  <img class="backimage"
                                    [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                                    <span>close</span>
                                  </button>
                                </div>
                              </kendo-window>
                            }

                            @if (_isEditForms) {
                              <asap-edit-forms
                                (close)="_onCloseEditForms($event)"
                                (saved)="_closeCustomFields()"
                                [page]="_page"
                                [permissionScope]="_permissionScope">
                              </asap-edit-forms>
                            }
                            @if (_deactivatedFormTabsForm) {
                              <kendo-window
                                title="Deactivated Forms"
                                (close)="_closeInactiveFormTabs()"
                                style="z-index: 10050;">
                                <div class="row no_row_margin margin-top-30">
                                  <div class="col-12 margin-top-10">
                                    <kendo-grid [data]="_deactivatedFormTabsGridData" [scrollable]="'none'">
                                      <!-- <kendo-grid-column field="name" title="Fields Name">
                                    </kendo-grid-column> -->
                                    <kendo-grid-column field="name" title="Tab Name">
                                    </kendo-grid-column>
                                    <kendo-grid-column field="createdOn" title="Added Date" type="date">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.createdOn | dateFormat}}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="lastUpdatedOn"
                                      title="Deactivation Date"
                                      type="date">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        {{dataItem.lastUpdatedOn | dateFormat}}
                                      </ng-template>
                                    </kendo-grid-column>
                                    <kendo-grid-column field="Command" title="Command">
                                      <ng-template kendoGridCellTemplate let-dataItem>
                                        <div class="action-button action-button-deactivate"
                                          (click)="_reactivateFormTab(dataItem)">
                                          <div class="action-button-icon">
                                            <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                          </div>
                                          <div class="edit-icon-text">Reactivate</div>
                                        </div>
                                      </ng-template>
                                    </kendo-grid-column>
                                  </kendo-grid>
                                </div>
                              </div>
                            </kendo-window>
                          }
